import ProductPricing from './ProductPricingWrapper';

export default ProductPricing;
